import { CompanyInDto } from 'shared/dtos/in/company';
import {
  CompanyCreateOutDto,
  CompanyEditOutDto,
} from 'shared/dtos/out/company';

export interface ICompanyUploader {
  POST: (url: string, data: CompanyCreateOutDto) => Promise<any>;
  PUT: (url: string, data: CompanyEditOutDto) => Promise<any>;
  DELETE: (url: string) => Promise<any>;
  GET: (url: string) => Promise<any>;
}

/** Resolves with the saved company, as the API answers an edit. */
export type UploadCompanyChanges = (
    uploader: ICompanyUploader,
    body: CompanyEditOutDto,
    url: string
  ) => Promise<CompanyInDto>;

export type UploadCompany = (
    uploader: ICompanyUploader,
    body: CompanyCreateOutDto,
    url: string
  ) => Promise<CompanyInDto>;

export type UploadCompanyDelete = (uploader: ICompanyUploader, url: string) => Promise<unknown>;

export type UploadCompanyRestore = (uploader: ICompanyUploader, url: string) => Promise<unknown>;

export function uploadCompanyChanges(
  uploader: ICompanyUploader,
  body: CompanyEditOutDto,
  url: string
): Promise<CompanyInDto> {
  return uploader.PUT(url, body);
}

export function uploadCompany(
  uploader: ICompanyUploader,
  body: CompanyCreateOutDto,
  url: string
): Promise<CompanyInDto> {
  return uploader.POST(url, { ...body });
}

export function uploadCompanyDelete(
  uploader: ICompanyUploader,
  url: string
): Promise<unknown> {
  return uploader.DELETE(url);
}

export function uploadCompanyRestore(
  uploader: ICompanyUploader,
  url: string
): Promise<unknown> {
  return uploader.GET(url);
}
